import {ArtefactDialogData} from "./dialog-data.model";
import {language} from "../language/language.const";

export class JobsDialogData extends ArtefactDialogData {
    saveBtnText: string;
    cancelBtnText: string;
    maxRolePriority: any;

    constructor(props: Partial<JobsDialogData> = {}) {
        super(props);
        this.saveBtnText = props.saveBtnText || language.general.SAVE;
        this.cancelBtnText = props.cancelBtnText || language.general.CANCEL;
        this.maxRolePriority = props.maxRolePriority;
    }
}